import React, { Component } from 'react';

class Contacts extends Component {
	constructor(props) {
		super(props);
		this.state = {
			filterBy: {}, sortBy: 'filename', sortOrder: 1,
			active: false,
			uploading: false,
			editing: false,
			viewingListVersions: false,
			page: 1,
			loading: false
		};
	}

	add = () => {
		this.setState({ contactList: false, binaryData: false, uploading: true, loading: false })
	}
	setFileName = (e) => {
		if (e.target.files.length > 0) {
			this.setState({ contactList: e.target.files[0] })
		} else {
			this.setState({ contactList: false })
		}
		this.fileReader = new FileReader()
		this.fileReader.onload = (event) => {
			this.setState({ binaryData: this.fileReader.result.split(';base64,').pop() })
		}
		this.fileReader.readAsDataURL(e.target.files[0])
	}
	confirmContactUpload = (e) => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'uploadContactList', contactList: { data: this.state.binaryData, file: this.state.contactList.name } }))
	}

	edit = (list) => (e) => {
		this.setState({ editing: list, page: 1, loading: false })
	}
	conf = () => {
		var replacements = this.state.replacements.slice()
		replacements.push(this.state.rep)
		this.setState({ editing: false, loading: false, replacements: replacements })
	}

	delete = (list) => (e) => {
		e.stopPropagation()
		this.setState({ deleting: list, loading: false })
	}
	confirmDelete = (e) => {
		this.setState({ loading: true })
		this.props.ws.send(JSON.stringify({ route: 'deleteContactList', list: this.state.deleting }))
	}

	cancel = () => {
		this.setState({ uploading: false, editing: false, deleting: false, loading: false, setting: false, viewingListVersions: false })
	}

	pageToNumber = (e) => {
		var newValue

		if (e.currentTarget.value < 1) {
			newValue = 1
		} else if (e.currentTarget.value > Math.max(1, this.state.editing.rows.length / 100)) {
			newValue = Math.max(1, this.state.editing.rows.length / 100)
		} else {
			newValue = e.currentTarget.value
		}
		this.setState({ page: newValue, loading: false })
	}

	sort = (sortBy) => (e) => {
		var sortOrder = this.state.sortOrder === -1 ? 1 : -1
		this.setState({ sortBy: sortBy, sortOrder: sortOrder })
	}

	filter = (newFilter) => (e) => {
		var filterBy = this.state.filterBy
		if (e.target.value.length > 0) {
			filterBy[newFilter] = e.target.value
		} else {
			delete filterBy[newFilter]
		}
		this.setState({ filterBy: filterBy })
	}

	sortFunc(sortBy, sortOrder) {
		return function (a, b) {
			if (sortBy === 'records') {
				return (a.rows.length - b.rows.length) * sortOrder
			}
			if (sortBy === 'version') {
				return (a.version - b.version) * sortOrder
			}
			if (sortBy in a && sortBy in b) {
				return a[sortBy].toString().toLowerCase() > b[sortBy].toString().toLowerCase() ? 1 * sortOrder : -1 * sortOrder
			}
			else if (!(sortBy in a) && !(sortBy in b)) {
				return a.filename.toString().toLowerCase() > b.filename.toString().toLowerCase() ? 1 * sortOrder : -1 * sortOrder
			} else {
				return sortBy in a ? -1 : 1
			}
		}
	}

	filterFunc(array, filterBy) {

		return array.filter(function (object) {
			for (var prop in filterBy) {
				if (prop === 'records') {
					if (object.rows.length.toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
						return false
					}
				} else if (prop === 'updatedDate') {
					if ((new Date(object.updatedDate).toDateString().substring(4) + ', ' + new Date(object.updatedDate).toLocaleTimeString()).toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
						return false
					}
				} else if (typeof object[prop] === "undefined") {
					return false
				} else if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
					return false
				}
			}
			return true
		})
	}
	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.cancel();
		}
	}

	loadVersions = (list) => (e) => {
		e.stopPropagation()
		this.setState({ viewingListVersions: list, loading: false })
		this.props.ws.send(JSON.stringify({ route: 'loadContactListVersions', listname: list.filename, id: list.id }))
	}
	base64ToBlob = (base64Data, contentType) => {

		contentType = contentType || '';
		var sliceSize = 1024;
		var byteCharacters = atob(base64Data);
		var bytesLength = byteCharacters.length;
		var slicesCount = Math.ceil(bytesLength / sliceSize);
		var byteArrays = new Array(slicesCount);

		for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
			var begin = sliceIndex * sliceSize;
			var end = Math.min(begin + sliceSize, bytesLength);

			var bytes = new Array(end - begin);
			for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
				bytes[i] = byteCharacters[offset].charCodeAt(0);
			}
			byteArrays[sliceIndex] = new Uint8Array(bytes);
		}
		return new Blob(byteArrays, { type: contentType });
	}
	componentDidUpdate(prevProps, prevState) {
		console.log(this.props.data.Contacts.download)
		console.log(prevProps.data.Contacts.download)
		if (this.props.data.Contacts.download) {

			if (window.navigator.msSaveOrOpenBlob) {
				console.log('This is IE!')
				var fileData = this.base64ToBlob(this.props.data.Contacts.download, "application/zip");
				var blobObject = new Blob([fileData]);

				window.navigator.msSaveOrOpenBlob(blobObject, this.state.downloading);
				delete this.props.data.Contacts.download
			} else {
				var url = window.URL.createObjectURL(this.base64ToBlob(this.props.data.Contacts.download, "application/zip"));
				var a = document.createElement("a");
				a.style = "display: none";
				a.href = url;
				a.download = this.state.downloading;

				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				delete this.props.data.Contacts.download
			}
		}

	}

	downloadList = (version) => (e) => {
		this.setState({ downloading: version })
		this.props.ws.send(JSON.stringify({ route: 'downloadContactList', listname: this.state.viewingListVersions.filename, version: version }))
	}
	render() {
		if (this.props.active) {
			var contactListList = []
			for (list in this.props.data.Contacts) {
				if (list != 'download') {
					contactListList.push(this.props.data.Contacts[list])
				}

			}

			if (Object.keys(this.state.filterBy).length > 0) {
				contactListList = this.filterFunc(contactListList.slice(), this.state.filterBy)
			}

			if (this.state.sortBy !== '') {
				contactListList.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
			}

			var contactLists = []
			for (var list of contactListList) {
				contactLists.push(
					<div className="dataRow" key={list.id} onClick={this.edit(list)}>
						<span style={{ flex: '0 0 320px' }}>{list.filename}</span>
						<span style={{ textAlign: 'center', flex: '0 0 60px' }}>{list.rows.length}</span>
						<span style={{ textAlign: 'center', flex: '0 0 270px' }}>{new Date(list.updatedDate).toDateString().substring(4) + ', ' + new Date(list.updatedDate).toLocaleTimeString()}</span>
						<span style={{ textAlign: 'center', flex: '1 0 200px' }}>{list.updatedUser}</span>
						<span style={{ textAlign: 'center', flex: '0 0 60px' }} onClick={this.loadVersions(list)}>{list.version}</span>
						<span className="buttonBox" style={{ flex: '0 0 50px' }}>
							<img src={this.props.img.delete} alt="Delete List" onClick={this.delete(list)} />
						</span>
					</div>
				)
			}

			var upload = ""
			if (this.state.uploading) {
				upload = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>Upload a New .csv File Contact List</div>
							<br /><br />
							<input style={{ width: '0.1px', height: '0.1px', opacity: '0', overflow: 'hidden', position: 'absolute', zIndex: '-1' }} type="file" id="wav" onChange={this.setFileName} />

							{this.state.contactList ?
								<div >
									<label style={{ display: 'inline-block', border: '1px solid #379', borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }} className="button" htmlFor="wav">Browse
									</label>

									<span style={{ display: 'inline-block', border: '1px solid #379', padding: '15px 29px', fontSize: '25px' }}>{this.state.contactList.name.split('\\')[this.state.contactList.name.split('\\').length - 1]}
									</span>

								</div>
								: <label className="button" htmlFor="wav">Browse</label>
							}

							<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

							{this.state.binaryData ? this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmContactUpload}>Upload</div> : ''}
						</div>
					</div>
				)
			}
			var edit = ""
			if (this.state.editing) {
				var listTable = []
				var headerRow = []
				for (var field of this.state.editing.headers) {
					headerRow.push(
						<th key={field} style={{ padding: '5px 20px' }}>{field}</th>
					)
				}
				listTable.push(
					<tr>{headerRow}</tr>
				)

				for (var i = (this.state.page - 1) * 100; i < Math.ceil(Math.min(this.state.page * 100, this.state.editing.rows.length)); i++) {
					var dataRow = []
					var row = this.state.editing.rows[i]
					if (row) {
						for (field of this.state.editing.headers) {
							var fieldData = row[field] instanceof Array ? JSON.stringify(row[field]) : row[field]
							dataRow.push(

								<td key={field + i} style={{ padding: '10px', border: '1px solid #bbb' }}>{fieldData}</td>
							)
						}
						listTable.push(
							<tr>{dataRow}</tr>
						)
					}
				}
				edit = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" style={{ width: ' min-content', position: 'relative', overflow: 'hidden', height: '80vh', width: '85vw' }}>
							<div style={{}} className="viewCloser" onClick={this.cancel}></div>
							<div>{this.state.editing.filename}</div>
							<div style={{ overflow: 'scroll', height: '75vh', width: '85vw' }}>
								<div style={{}}>
									<table style={{ boxSizing: 'content-box', width: 'calc(84vw - 10px)', borderCollapse: "collapse" }}>
										<tbody>
											{listTable}
										</tbody>
									</table>
								</div>
							</div>

							<div style={{ display: 'flex', justifyContent: 'space-around' }}>
								{this.state.page > 1 ?
									<div style={{ padding: '10px', textAlign: 'center', flex: '1 0 30%' }} onClick={() => { this.setState({ page: this.state.page - 1 }) }}>{'<<< Previous'}</div>
									:
									<div style={{ padding: '10px', textAlign: 'center', flex: '1 0 30%' }}></div>

								}
								<div style={{ padding: '10px', textAlign: 'center', flex: '1 0 30%' }}>
									<span>Page </span>
									<input onChange={this.pageToNumber} style={{ border: "1px solid #2A6AA9", padding: "5px", width: "50px" }} type="number" min="1" max={Math.max(1, Math.ceil(this.state.editing.rows.length / 100))} value={this.state.page}></input>

									<span> of {Math.max(1, Math.ceil(this.state.editing.rows.length / 100))}</span>
								</div>
								{this.state.page < (Math.ceil(this.state.editing.rows.length / 100)) ?
									<div style={{ padding: '10px', textAlign: 'center', flex: '1 0 30%' }} onClick={() => { this.setState({ page: this.state.page + 1 }) }}>{'Next >>>'}</div>
									:
									<div style={{ padding: '10px', textAlign: 'center', flex: '1 0 30%' }}></div>
								}
							</div>
						</div>
					</div>
				)
			}
			var del = ""
			if (this.state.deleting) {
				del = (
					<div className="blackout">
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>You Are Removing Contact List</div>
							<div style={{ margin: "15px" }}> {this.state.deleting.filename} </div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmDelete}>Delete Contact List</div>}
						</div>
					</div>
				)
			}

			var listVersions = ''
			if (this.state.viewingListVersions) {
				var versions = []
				if (this.state.viewingListVersions.versionList) {
					for (var version of this.state.viewingListVersions.versionList) {
						versions.push(<div className="dataRow" onClick={this.downloadList(version)}>{new Date(parseInt(version.match(/\d*?.csv/gm)[0])).toLocaleString()}</div>)
					}
				}
				listVersions = (
					<div className="blackout">
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>Previous Versions of Contact List</div>
							<div style={{ margin: "15px" }}> {this.state.viewingListVersions.filename} </div>
							{versions}
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.cancel}>Close</div>}
						</div>
					</div>
				)
			}
			return (
				<div className="viewContent" id="reportView" >
					<img src={this.props.img.plus} className="plusButton" alt="Add" onClick={this.add} />
					<div className="dataHeaders">
						<span style={{ textAlign: 'left', paddingLeft: '5px', flex: '0 0 300px', cursor: 'pointer' }} onClick={this.sort('filename')}>Contact List Name</span>
						<span style={{ textAlign: 'center', flex: '0 0 60px', cursor: 'pointer' }} onClick={this.sort('records')}>Records</span>
						<span style={{ textAlign: 'center', flex: '0 0 270px', cursor: 'pointer' }} onClick={this.sort('updatedDate')}>Updated</span>
						<span style={{ textAlign: 'center', flex: '1 0 200px', cursor: 'pointer' }} onClick={this.sort('updatedUser')}>User</span>
						<span style={{ textAlign: 'center', flex: '0 0 60px', cursor: 'pointer' }} onClick={this.sort('version')}>Version</span>
						<span style={{ flex: '0 0 103px' }}></span>
					</div>
					<div className="dataFilters">
						<input style={{ flex: '0 0 300px' }} type="text" onChange={this.filter("filename")} value={this.state.filterBy.filename} />
						<input style={{ maxWidth: '60px', flex: '0 0 60px' }} type="text" onChange={this.filter("records")} value={this.state.filterBy.records} />
						<input style={{ flex: '0 0 270px' }} type="text" onChange={this.filter("updatedDate")} value={this.state.filterBy.updatedDate} />
						<input style={{ flex: '1 0 200px' }} type="text" onChange={this.filter("updatedUser")} value={this.state.filterBy.updatedUser} />
						<input style={{ maxWidth: '60px', flex: '0 0 60px' }} type="text" onChange={this.filter("version")} value={this.state.filterBy.version} />
						<span style={{ flex: '0 0 103px' }} ></span>
					</div>
					<div style={{ overflow: 'auto', height: 'calc(100% - 85px)' }}>
						{contactLists}
						{upload}
						{edit}
						{del}
						{listVersions}
					</div>
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

const icon = "menuConverse"
const roles = ["View", "Add", "Edit", "Delete"]

export { Contacts, roles, icon }